enum ActionTypes {
  ADD_NOTIFICATION = 'SigningCaseDetails/ADD_NOTIFICATION',
  REMOVE_NOTIFICATION = 'SigningCaseDetails/REMOVE_NOTIFICATION',
  CLEAR_NOTIFICATIONS = 'SigningCaseDetails/CLEAR_NOTIFICATIONS',
}

export default ActionTypes;
